import { create } from "zustand";
import { State } from "@/models";

export const useComponentStore = create<State.UI>((set) => ({
  setAllState: (newState: State.UI) => {
    set(() => ({ ...newState }));
  },
  modal: {
    set: (
      width: number,
      children: JSX.Element,
      showCloseButton?: boolean,
      title?: string | JSX.Element,
      closable?: boolean,
      clearAll?: boolean,
      noCloseButton?: boolean,
      isDetails?: boolean
    ) => {
      set((state: State.UI) => ({
        ...state,
        modal: {
          ...state.modal,
          width,
          children,
          showCloseButton,
          title,
          open: true,
          closable,
          clearAll,
          noCloseButton,
          isDetails,
        },
      }));
    },
    toogle: () => {
      set((state: State.UI) => ({
        ...state,
        modal: { ...state.modal, open: !state.modal?.open },
        componentSteps: 0,
        px: undefined,
        py: undefined,
      }));
    },
  },
  setState: (key: keyof State.UI, value: any) => {
    set((state: State.UI) => ({
      ...state,
      [key]: value,
    }));
  },
}));
